<div *ngIf="isMenuShown" [ngClass]="{'absolute top-1 right-1 flex items-center pl-1.5 pb-1' : cornerPosition }">
  <button [matMenuTriggerFor]="langMenu" mat-mini-fab>
    <mat-icon svgIcon="globe" class="action" data-test="locale"></mat-icon>
  </button>

  <mat-menu #langMenu="matMenu">
    <button *ngFor="let locale of LOCALES" (click)="changeLocale(locale)" mat-menu-item data-test="languages">{{'select.locale.' + locale | translate}}</button>
  </mat-menu>
</div>
